import { t } from 'i18next'
import { z } from 'zod'

import { InputOption } from '@/types'

export const MODES = ['both', 'salesType', 'quantity'] as const

export const modeOptions: InputOption<(typeof MODES)[number]>[] = [
  { value: 'both', label: t('favorite.bulkUpdate.mode.both') },
  { value: 'salesType', label: t('favorite.bulkUpdate.mode.salesType') },
  { value: 'quantity', label: t('favorite.bulkUpdate.mode.quantity') },
]

const MIN_LENGTH = {
  quantity: 0,
}
const MAX_LENGTH = {
  quantity: 999,
  note: 20,
}

export const schema = z.object({
  salesType: z.string().nonempty(),
  quantity: z
    .number({ invalid_type_error: '必須項目です' })
    .min(MIN_LENGTH.quantity, `${MIN_LENGTH.quantity}未満です`)
    .max(MAX_LENGTH.quantity, `${MAX_LENGTH.quantity}を超えています`),
})

export const bulkUpdateFavoriteItemsSchema = z.object({
  mode: z.enum(['both', 'salesType', 'quantity']),
  salesType: z.string().optional(),
  quantity: z
    .number()
    .min(1, { message: t('favorite.bulkUpdate.validation.min', { min: 1 }) })
    .max(999, {
      message: t('favorite.bulkUpdate.validation.max', { max: 999 }),
    }),
})
